import React, { createContext, useContext, useState, useCallback } from 'react';
import { getCurrentMonth } from '../lib/utils';

const MonthContext = createContext();

export const useMonth = () => {
 const context = useContext(MonthContext);
 if (!context) {
 throw new Error('useMonth must be used within MonthProvider');
 }
 return context;
};

const STORAGE_KEY = 'selectedMonth';

export const MonthProvider = ({ children }) => {
 const [currentMonth, setCurrentMonth] = useState(() => {
 return localStorage.getItem(STORAGE_KEY) || getCurrentMonth();
 });

 const selectMonth = useCallback((year, month) => {
 const value = `${year}-${String(month).padStart(2, '0')}`;
 localStorage.setItem(STORAGE_KEY, value);
 setCurrentMonth(value);
 }, []);

 const value = {
 currentMonth,
 selectMonth,
 };

 return <MonthContext.Provider value={value}>{children}</MonthContext.Provider>;
};
